import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value: any): object {
    const returnedArray = Object.keys(value).filter(e => !isNaN(+e)).map(o => ({index: +o, name: value[o]}));
    return returnedArray;
  }

}
